export const styles = {
  fab: {
    position: "fixed"
  }
};
